import { createStore } from "vuex";
const THEME_KEY = "app_theme";
export default createStore({
  state: {
    theme: localStorage.getItem(THEME_KEY) || "system",
    systemTheme: "light",
  },
  getters: {
    actualTheme: (state) => {
      if (state.theme === "system") {
        return state.systemTheme;
      }
      return state.theme;
    },
  },
  mutations: {
    SET_THEME(state, theme) {
      state.theme = theme;
      localStorage.setItem(THEME_KEY, theme);
    },
    SET_SYSTEM_THEME(state, systemTheme) {
      state.systemTheme = systemTheme;
    },
  },
  actions: {
    setTheme({ commit, dispatch }, theme) {
      commit("SET_THEME", theme);
      dispatch("applyTheme");
    },
    setSystemTheme({ commit, dispatch }, systemTheme) {
      commit("SET_SYSTEM_THEME", systemTheme);
      if (this.state.theme === "system") {
        dispatch("applyTheme");
      }
    },
    applyTheme({ state }) {
      const actualTheme =
        state.theme === "system" ? state.systemTheme : state.theme;
      document.documentElement.setAttribute("data-theme", actualTheme);
    },
    initTheme({ commit, dispatch }) {
      if (typeof window !== "undefined" && window.matchMedia) {
        const isDark = window.matchMedia(
          "(prefers-color-scheme: dark)"
        ).matches;
        commit("SET_SYSTEM_THEME", isDark ? "dark" : "light");
        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
        mediaQuery.addEventListener("change", (e) => {
          dispatch("setSystemTheme", e.matches ? "dark" : "light");
        });
      }
      dispatch("applyTheme");
    },
  },
});
